export default "__VITE_ASSET__BdOoKXe6__"